import { render, staticRenderFns } from "./ReportVictim.vue?vue&type=template&id=9310e5d0"
import script from "./ReportVictim.vue?vue&type=script&lang=js"
export * from "./ReportVictim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports